/**
 * confirm-route-change.js
 */

import React from "react";
import { useHistory, Prompt } from 'react-router-dom';
import { AppUtilityContext } from 'contexts/app-utility/app-utility-context';
import ConfirmDialog from 'components/confirm-dialog';


export default function ConfirmRouteChange(props) {
  const {
    when,
    shouldBlockNavigation,
    title,
    content,
    okText,
    cancelText,
    save,
    navAction,
  } = props;
  let history = useHistory();
  const { alertError } = React.useContext(AppUtilityContext);
  const [lastLocation, setLastLocation] = React.useState(null);
  const [doNav, setDoNav] = React.useState(false);
  const [confirmNavigation, setConfirmNavigation] = React.useState();

  // action options
  let actions = [
    {
      label: cancelText || 'Cancel',
      value: 'stay',
      isNotPriority: true,
    },
  ];
  actions.push({
    label: okText || 'OK',
    value: 'nav',
  });
  if (save) {
    actions.push({
      label: 'Save Changes',
      value: 'save'
    });
  }


  React.useEffect(() => {
    if (doNav && lastLocation) {
      // nav to the previous blocked location
      history.push(lastLocation);
      // reset do nav so we properly trigger on next change
      setDoNav(false);
    }
  }, [doNav, lastLocation, history]);


  React.useEffect(() => {
    const onBeforeUnload = (e) => {
      if (when) {
        e.preventDefault();
        e.returnValue = true;
        return true;
      }
      return false;
    }
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [when]);


  const handleBlockedNav = (nextLocation) => {
    if (!doNav && shouldBlockNavigation(nextLocation)) {
      setLastLocation(nextLocation);
     
      (async () => {
        let response = await confirmNavigation();

        if (response === 'nav') {
          if (navAction) {
            navAction();
          }
          setDoNav(true);
        } else if (response === 'save') {
          try {
            if (await save()) {
              setDoNav(true);
            }
          } catch (e) {
            alertError({ text: e.message });
          }
        }
      })();
      return false;
    }
    return true;
  }


  return (
    <>
      <Prompt when={when} message={handleBlockedNav} />
      <ConfirmDialog
        title={title}
        titleIcon='info'
        content={content}
        setConfirm={setConfirmNavigation}
        customActions={actions}
      />
    </>
  );
}